import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, Data } from '@angular/router';

import { PERMISSIONS } from '@app/lib/permissions';

import { Session } from '../services/session';

interface IFleetCardsRolesPermissionsGuard {
  name: PERMISSIONS | PERMISSIONS[];
  redirectTo?: string;
}

@Injectable()
export class FleetCardsRolesPermissionsGuard {
  constructor(
    private router: Router,
    private session: Session,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const session: Session = this.session;
    const data: Data = route.data;
    const config: IFleetCardsRolesPermissionsGuard = data.fleetCardsRolesPermissionsGuard;
    const { name,redirectTo } = config;

    let featureNotAccessible: boolean;
    if (Array.isArray(name)) {
      featureNotAccessible = !name.some((permisson: PERMISSIONS) => session.isFeatureAllowed(permisson));
    } else {
      featureNotAccessible = !session.isFeatureAllowed(name);
    }
    if (featureNotAccessible) {
      this.router.navigate([redirectTo]);
      return false;
    }
    return true;
  }
}
